function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#4A4A4A"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.846 2.43c-.422-.185-.913.008-1.098.43-.184.421.009.913.43 1.097 2.712 1.184 4.502 3.866 4.502 6.876 0 4.142-3.359 7.5-7.5 7.5-4.143 0-7.5-3.358-7.5-7.5 0-3.01 1.789-5.691 4.5-6.876.42-.185.613-.676.429-1.098-.184-.421-.676-.614-1.097-.43-3.313 1.449-5.5 4.727-5.5 8.404C.013 15.896 4.118 20 9.18 20c5.062 0 9.166-4.104 9.166-9.167 0-3.678-2.187-6.956-5.5-8.403z",
  transform: "translate(-1078 -447) translate(1048 85) translate(30 362)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.18 9.167c.46 0 .833-.373.833-.834v-7.5c0-.46-.374-.833-.834-.833-.46 0-.833.373-.833.833v7.5c0 .46.373.834.833.834z",
  transform: "translate(-1078 -447) translate(1048 85) translate(30 362)"
})))));

var SvgTurnOff = function SvgTurnOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTurnOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/turnOff.5dfc03e6.svg";
export { ForwardRef as ReactComponent };